import {App } from "../shared/components/mzl-subjects/app/index";
import "./mzl-subjects.module.scss";


const { createApp }  = Vue;

(function (window) {    
    function _init(config) {

        const app = createApp(App);
        app.config.globalProperties.rootData = {
            dataSource: config.jsonUrl,
            text: config.text,
        };
        app.mount(config.container);        
    }

    window.LmuFacherkombinator = {
        init: _init
    }
})(window);
  
  
